import { AccountRequestsMock } from './accountRequestsMocks'

export async function fetchAccountRequests() {
  return AccountRequestsMock
}
